/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-27 11:16
 * @LastEditors: wenbin.ma@ginlong.com
 * @LastEditTime: 2026-04-23 13:49
 * @FilePath: \glyun_web_vue3\src\api\axios\request.js
 * @Description: axios请求相应拦截器
 */
import axios from 'axios'
import router from '@/router'
import { useUserStore } from '@/stores/user'
import i18n from '@/lang' // 导入你的 i18n 实例
const t = i18n.global.t
// import initApiStore from './apiStore.js'
// const apiStore = new initApiStore()
// console.log("🚀 ~ apiStore:", apiStore)
// 创建axios实例
const service = axios.create({
  // 开发环境使用代理路径，生产环境使用完整URL（安全修复Q3：支持 Cookie 代理）
  baseURL: import.meta.env.DEV ? '/api/' : import.meta.env.VITE_API_BASE_URL,
  //根据不同平台需要添加-（GLY=锦浪云、ZX=中性、AX=德国Axitecd、LT=路特斯、PC=Polycab、OSS=OSS、JXB=晶享宝、GLCY=资产运维、SSC=储能云）
  headers: {'X-Cloud-Platform': import.meta.env.VITE_CLOUD_PLATFORM_KEY},
  timeout: 20000,
  retry: 0, // 重试次数
  retryDelay: 1000, // 重试延迟时间(ms)
  withCredentials: true, // 启用跨域携带Cookie（安全修复Q3）
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 检查该请求是否已经重复，重复则进行取消并移除
    // apiStore.cancelPending(config)
    // 添加新的请求到容器中
    // apiStore.addPending(config)

    // 大屏分享 token 优先（Q5 场景）
    const shareToken = getUrlToken()
    if (shareToken) {
      config.headers.token = shareToken
      return config
    }

    // 【兼容过渡期】如果 localStorage 中存在 token，仍然发送到 header（安全修复Q3）
    // 新用户登录后，token 由 HttpOnly Cookie 自动携带
    // 后端优先校验 Cookie，其次校验 header token
    const localToken = localStorage.getItem('token')
    if (localToken) {
      config.headers.token = localToken
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

let linkLapseHide = true;
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    console.log("🚀 ~ response:", response)
    // 移除容器中的储存的接口
    // apiStore.removePending(response.config)
    console.log("🚀 ~ response: 测试", )
    if(response.data.code === "Z0001"){
      // 大屏分享链接失效不退出
      if (getShareToken()) {
        if(linkLapseHide){
          linkLapseHide = false
          ElMessageBox.alert(t("v2_share_link_expired"), t("v2_inverter_details_tip"), {
            confirmButtonText: t("v2_global_i_understand"),
            showClose:false,
            callback: action => {
              linkLapseHide = true
              router.push('/overview/plantStation')
            }
          })
        }

      } else {
        const userStore = useUserStore()
        // router.push('/')
        userStore.logout()
        ElMessage.error(response.data.msg)
      }
    }else{
      return Promise.resolve(response)
    }
  },
  (error) => {
    console.log("🚀 ~ error:", error)
    // 请求失败也要移除
    // apiStore.removePending(error.message)
    if(error.code === 'ECONNABORTED'){
      ElMessage({
        message: t('v2_global_timeout_please_retry'),
        grouping: true,
        type: 'error',
      })
    }
    if (axios.isCancel(error)) {
      console.log('已取消的重复请求：', error.message)
    } else {
      // 请求失败重试逻辑
      const config = error.config
      if (config && config.retry && config.__retryCount < config.retry) {
        config.__retryCount = config.__retryCount || 0
        config.__retryCount += 1

        const backoff = new Promise((resolve) => {
          setTimeout(() => {
            resolve()
          }, config.retryDelay || 1000)
        })

        return backoff.then(() => {
          return service(config)
        })
      }
    }

    return Promise.reject(error)
  },
)

// 判断大屏是否为分享链接如果是则拿token
function getUrlToken() {
  const shareToken = getShareToken()
  if (shareToken) {
    return shareToken
  }
  const url = new URL(window.location.href);
  const token = url?.searchParams?.get('token');
  if(window.location.href?.indexOf('/modify_password') != -1 && token){
    return token
  }

  return false
}

function getShareToken() {
  if (
    window.location.href.indexOf('/largeScreen/stationsMultiple') !== -1
  ){
    return router.currentRoute.value.query.token
  }
}

export default service
